module.exports = __webpack_public_path__ + "img/Stage_8_Atmo.49559534.jpg";